import React, { memo } from "react";

const RangeCard = ({ item, onBetting, isWin, oldResult }) => {
    if (!item) return null;

    const isWinner = isWin && oldResult?.numberCode === item.code;

    const handleClick = () => {
        if (typeof onBetting === "function") {
            onBetting(item);
        }
    };

    const className = `range-card ${isWinner ? "win-animation" : ""}`;

    return (
        <div onClick={handleClick} className={className}>
            <div className="range-title">{item.rangeNumber}</div>

            <div className="content m-range">
                <div className="score p-0">{item.value}</div>
            </div>
        </div>
    );
};

export default memo(RangeCard);